// extracted by mini-css-extract-plugin
export default {"prop":"prop_node-module___prop___bf61c862","propValue":"prop_node-module___propValue___bc45922c"};